/**
 * gm-pdp-fold — altura da foto main em tela baixa (spec 0130).
 *
 * Mede a largura que a main teria no fold travado. Se ficar menor que
 * 2.5 tiles mínimos (2.5 × 72 + 1.5 × 2 = 183px), marca `is-fold-open`:
 * o fold solta a altura e a foto ocupa o espaço livre da 1ª tela.
 * Tiles, preço e ATC ficam no scroll. `?pdpfold=locked` mantém o fold
 * travado de hoje.
 *
 * Síncrono, logo após o hero, antes de `gm-pdp-scroll.js` (defer)
 * capturar `--gm-pdp-main-lock`.
 */
(function () {
  const DESKTOP_MIN = 750;
  const TILE_MIN_W = 72;
  const GAP = 2;
  const TRIGGER_TILES = 2.5;
  const THRESHOLD = TRIGGER_TILES * TILE_MIN_W + (TRIGGER_TILES - 1) * GAP;
  const BOTTOM_GAP = 16;
  const MIN_H = 240;
  const script = document.currentScript;
  const hero = script && script.previousElementSibling;
  if (!hero || !hero.classList.contains('gm-pdp-hero')) return;

  const locked = new URLSearchParams(window.location.search).get('pdpfold') === 'locked';
  const main = hero.querySelector('.gm-pdp-hero__main');

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MIN;
  }

  /** Largura da main no fold travado (sem is-fold-open e sem lock). */
  function naturalMainWidth() {
    if (!main) return 0;
    const hadOpen = hero.classList.contains('is-fold-open');
    const lock = hero.style.getPropertyValue('--gm-pdp-main-lock');
    hero.classList.remove('is-fold-open');
    if (lock) hero.style.removeProperty('--gm-pdp-main-lock');
    const w = main.getBoundingClientRect().width;
    if (lock) hero.style.setProperty('--gm-pdp-main-lock', lock);
    if (hadOpen) hero.classList.add('is-fold-open');
    return w;
  }

  /**
   * Altura da main = espaço livre entre o topo dela (abaixo de badge +
   * nome + cor) e o fim da 1ª tela. Medido no documento, então não varia
   * com o scroll. A largura sai do 3:4 no CSS.
   */
  function sizeMainToFold() {
    if (!main || !hero.classList.contains('is-fold-open')) {
      hero.style.removeProperty('--gm-pdp-fold-main-h');
      return;
    }
    const top = main.getBoundingClientRect().top + (window.scrollY || 0);
    const h = Math.max(MIN_H, Math.floor(window.innerHeight - top - BOTTOM_GAP));
    hero.style.setProperty('--gm-pdp-fold-main-h', h + 'px');
  }

  function measure() {
    if (locked || !isDesktop() || !main) {
      hero.classList.remove('is-fold-open');
      hero.style.removeProperty('--gm-pdp-fold-main-h');
      return;
    }
    const w = naturalMainWidth();
    hero.classList.toggle('is-fold-open', w < THRESHOLD);
    sizeMainToFold();
  }

  measure();

  let raf = 0;
  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      raf = 0;
      measure();
    });
  }
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
})();
